import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import LeaveDocumentsDrawer from "../LeaveApplications/LeaveDocumentsDrawer";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import { leaveApplications, leaveApprovals } from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";

const base_url = HRService.uri;

function LeaveApprovalsTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
    entity: "Leave Approvals",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

    approve: {
      key: "APPROVE_LEAVE",
      button_name: "Approve Leave",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    decline: {
      key: "REJECT_LEAVE",
      button_name: "Reject Leave",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
    // dataObject: {
    //   inputObjectName: "approveDeclineLeaveApplication",
    //   inputSubObjectName: "applicationsApprovals",
    //   inputFields: ["applicationId", "userId", "comments"],
    // },

    actionName: "Leave Application ",
    showStatus: true,
  };

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Leave Approvals"
          subtitle="Approve or reject leave applications"
          columns={LeaveApplicationsColumns}
          query={leaveApprovals}
          actions={actions}
          base_url={base_url}
        />
        <LeaveDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          leaveApplicationId={selectedRecordForDocs?.applicationId ?? selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default LeaveApprovalsTable;
